// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'expense.term': 'Due on receipt | {count} days',
    'expense.custom': 'Custom',

    'expense.page.title': 'Expenses',
    'expense.page.title.duplicate': 'Duplicate Expense',
    'expense.page.search_results': 'Search Results',
    'expense.page.create.title': 'Create New Expense',
    'expense.page.search.title': 'Find Expenses',
    'expense.page.edit.title': 'Edit Expense',
    'expense.page.view.history': 'Audit Trail',
    'expense.page.all': 'All',

    'expense.button.duplicate': 'Duplicate',
    'expense.button.cancel': 'Cancel',
    'expense.button.select': 'Select',
    'expense.button.find': 'Find Expenses',
    'expense.button.search': 'Apply',
    'expense.button.create': 'Save Expense',
    'expense.button.new': 'New Expense',
    'expense.button.save': 'Save Changes',
    'expense.button.void': 'Void Expense',
    'expense.button.refund': 'Refund Expense',
    'expense.button.edit': 'Edit',
    'expense.button.draft': 'Save Draft',
    'expense.button.restore': 'Restore',
    'expense.button.reset': 'Reset',
    'expense.button.record_payment': 'Record Payment',
    'expense.button.history': 'Audit Trail',
    'expense.button.rollback': 'Rollback Expense',
    'expense.button.cancel_draft': 'Cancel Draft',

    'expense.placeholder.search': 'Search expenses',

    'expense.message.no_change': 'This expense has not changed since it was created.',

    'expense.link.create_first_expense': 'Click here to create your first expense',
    'expense.link.expenses': ' Return to Expenses',
    'expense.link.retry': 'Click here to retry',

    'expense.checkbox.all': 'Check All',
    'expense.checkbox.actions_label': 'with selected',

    'expense.label.expense': 'Expense',
    'expense.label.expense_type': 'Expense Type',
    'expense.label.expense_category': 'Expense Category',
    'expense.label.date': 'Date',
    'expense.label.due': 'Due',
    'expense.label.item': 'Description',
    'expense.label.unit_cost': 'Unit Cost',
    'expense.label.quantity': 'Quantity',
    'expense.label.tax': 'Tax',
    'expense.label.account': 'Account',
    'expense.label.total': 'Total',
    'expense.label.tax_total': 'Tax Total',
    'expense.label.grand_total': 'Grand Total',
    'expense.label.sub_total': 'Subtotal',
    'expense.label.discount': 'Discount',
    'expense.label.bill_from': 'Bill From',
    'expense.label.balance': 'Balance',
    'expense.label.subject': 'Subject',
    'expense.label.to': 'To',
    'expense.label.message': 'Message',
    'expense.label.transaction_date': 'Transaction Date',
    'expense.label.paid_at': 'Paid At',
    'expense.label.due_at': 'Due At',
    'expense.label.received_credit': 'Did you receive credit for this expense?',
    'expense.label.refund_reason': 'Reason for refunding expense',
    'expense.label.is_imported': 'Imported',
    'expense.label.imported': 'IMPORTED',

    'expense.label.entity_name': 'Supplier',
    'expense.label.contact_entity_name': 'Contact',
    'expense.label.contact_name': 'Contact Name',
    'expense.label.address_line_1': 'Address Line 1',
    'expense.label.address_line_2': 'Address Line 2',
    'expense.label.province': 'Province',
    'expense.label.postal_code': 'Postal Code',
    'expense.label.country_name': 'Country',
    'expense.label.reference_number': 'Reference No',
    'expense.label.purchase_order': 'Purchase Order',
    'expense.label.term': 'Term',
    'expense.label.currency_name': 'Currency',

    'expense.label.currency_sub_total_in_cents': 'Subtotal',
    'expense.label.currency_discount_total_in_cents': 'Discount Total',
    'expense.label.currency_tax_total_in_cents': 'Tax Total',
    'expense.label.currency_grand_total_in_cents': 'Grand Total',
    'expense.label.currency_balance_owing_in_cents': 'Balance Owing',
    'expense.label.currency_shipping_total_in_cents': 'Shipping Total',
    'expense.label.system_shipping_total_in_cents': 'System Shipping Total',

    'expense.label.sold_by': 'Sold By',
    'expense.label.public_customer_message': 'Public Customer Message',
    'expense.label.private_note': 'Private Note',
    'expense.label.created_at': 'Created on',
    'expense.label.void_reason': 'Reason for voiding expense',
    'expense.label.cancel_reason': 'Reason for canceling expense',
    'expense.label.rollback_reason': 'Reason for rolling back expense',

    'expense.sort.field_label': 'Field',
    'expense.sort.direction_label': 'Direction',
    'expense.sort.direction_ascending': 'Ascending',
    'expense.sort.direction_descending': 'Descending',

    'expense.modal.title.expense_void': 'Void Expense',
    'expense.modal.title.expense_restore': 'Restore Expense',
    'expense.modal.title.expense_cancel': 'Cancel Draft Expense',
    'expense.modal.title.expense_rollback': 'Rollback Expense',
    'expense.modal.title.expense_refund': 'Refund Expense',

    'expense.modal.message.expense_void': 'Are you sure that you want to void this expense? This action cannot be undone. | Are you sure that you want to void these expenses? This action cannot be undone.',
    'expense.modal.message.expense_restore': 'Are you sure that you want to restore this expense? | Are you sure that you want to restore these expenses?',
    'expense.modal.message.expense_cancel': 'Are you sure that you want to cancel this draft? This action cannot be undone.| Are you sure that you want to cancel these drafts? This action cannot be undone.',
    'expense.modal.message.expense_refund': 'Are you sure that you want to refund this expense? | Are you sure that you want to refund these expenses?',

    'expense.success.message.expense_created': 'Your expense has been created',
    'expense.success.message.expense_updated': 'Your expense has been updated',
    'expense.success.message.expense_restored': 'Your expense has been restored | All selected expenses were restored',
    'expense.success.message.expense_cancelled': 'Your draft expense has been cancelled',
    'expense.success.message.expense_voided': 'Your expense has been voided',
    'expense.success.message.expense_rolled_back': 'Your expense has been rolled back',

    'expense.error.message.edit_not_allowed': "The expense has been updated and can't be saved.",
    'expense.error.message.expense_deleted': 'This expense was already permanently deleted | These expenses were already permanently deleted',
    'expense.error.message.expense_restored': 'This expense was already restored | These expenses were already restored',
    'expense.error.message.error_loading_page': 'Sorry, there was an error loading expense.| Sorry, there was an error loading expenses.',
};
